import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  :root{
    --color-navy-blue: #101D40;
    --color-alba-grandeza: #7C8DB5;
    
    --color-green: #35BA83;

    --color-blue-medium-dark: #25396F;
    --color-blue: #329BFC;
    --color-blue-opacity-50: #96cdff;
    --color-blue-opacity-10: rgba(50 155 252 / 10%);
    --color-blue-opacity-25: rgba(50 155 252 / 25%);
    
    --color-red: #F64444;
    --color-red-opacity-10: rgba(246, 68, 68, 0.1);
    --color-red-opacity-25: rgba(246, 68, 68, 0.25);
    
    --color-gray-900: #E6EFFB;
    --color-gray-800: #AEAEAE;
    
    --color-back-opacity-10: rgba(0,0,0,0.12);
  }

  * {
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;
  }

  body {
    background: #ffffff;
    color: #1a1a1a;
    -webkit-font-smoothing: antialiased;
  }

  body, input, button, textarea {
    font-family: 'Roboto', sans-serif;
  }

  h1, h2, h3, h4, h5, h6, strong {
    font-weight: 500;
  }

  button {
    cursor: pointer;
  }

  ul, li {
    list-style: none;
  }
`;
